import React from 'react';
import PropTypes from 'prop-types';
import UamMessagePanel from '../../../../shared-panels/uam/UamMessagePanel/UamMessagePanel';

const AlreadyRegisteredPanel = ({ email }) => (
  <UamMessagePanel
    header="Account Already Registered"
  >
    An account is already registered for {email}. Please sign in using{' '}
    your email and password. You can reset your password if needed.
  </UamMessagePanel>
);

AlreadyRegisteredPanel.propTypes = {
  email: PropTypes.string.isRequired,
};

export default AlreadyRegisteredPanel;
